import UIComponent from "../ui/component.js";
import AmoCrmIntegrationApi from "../api/amocrmIntegration.js";

export class AmoCrmIntegration extends UIComponent {
    init() {
        this.hasIntegration = this.element.dataset.hasIntegration === '1';
        this.confirmDeleteMessage = this.element.dataset.confirmDelete;
        this.messageSaved = this.element.dataset.messageSaved;
        this.messageDeleted = this.element.dataset.messageDeleted;

        this.includeComponents({
            'subdomainInput': 'document@#subdomain',
            'domainInput': 'document@#domain',
            'domainDropdownToggle': 'document@#domainToggle',
            'accountIdInput': 'document@#account_id',
            'accessTokenInput': 'document@#access_token',
            'isActiveInput': 'document@#is_active',
            'saveBtn': 'document@#amoCrmSaveBtn',
            'deleteBtn': 'document@#amoCrmDeleteBtn',
            'successAlert': 'document@[data-tbx-name="successAlert"]',
        });

        this.element.querySelectorAll('[data-domain-value]').forEach((btn) => {
            btn.addEventListener('click', () => this.onDomainSelect(btn));
        });

        this.saveBtn?.on('click', this.onSave.bind(this));
        this.deleteBtn?.on('click', this.onDelete.bind(this));
    }

    onDomainSelect(btn) {
        const value = btn.dataset.domainValue;
        this.domainInput.element.value = value;

        if (this.domainDropdownToggle?.element) {
            this.domainDropdownToggle.element.textContent = btn.textContent.trim();
        }

        btn.closest('.dropdown-menu')?.querySelectorAll('.dropdown-item').forEach((el) => {
            el.classList.remove('active');
        });
        btn.classList.add('active');
    }

    collectPayload() {
        const accountIdRaw = this.accountIdInput.element.value.trim();
        const accountId = accountIdRaw === '' ? null : parseInt(accountIdRaw, 10);

        return {
            subdomain: this.subdomainInput.element.value.trim(),
            domain: this.domainInput.element.value,
            account_id: accountId,
            access_token: this.accessTokenInput.element.value.trim(),
            is_active: this.isActiveInput.element.checked,
        };
    }

    async onSave(e) {
        e.preventDefault();
        this.clearErrors();
        this.setLoading(this.saveBtn, true);

        const payload = this.collectPayload();

        try {
            if (this.hasIntegration) {
                await AmoCrmIntegrationApi.update(payload);
            } else {
                await AmoCrmIntegrationApi.store(payload);
            }

            window.location.reload();
        } catch (errors) {
            this.showErrors(errors);
            this.setLoading(this.saveBtn, false);
        }
    }

    async onDelete(e) {
        e.preventDefault();

        if (!confirm(this.confirmDeleteMessage)) {
            return;
        }

        this.clearErrors();
        this.setLoading(this.deleteBtn, true);

        try {
            await AmoCrmIntegrationApi.destroy();
            window.location.reload();
        } catch (errors) {
            this.showErrors(errors);
            this.setLoading(this.deleteBtn, false);
        }
    }

    showErrors(errors) {
        if (!errors || typeof errors !== 'object') {
            return;
        }

        Object.entries(errors).forEach(([field, message]) => {
            const input = this.getFieldInput(field);
            const feedback = this.element.querySelector(`.invalid-feedback-${field}`);

            if (input) {
                input.classList.add('is-invalid');
            }

            if (field === 'domain' && this.domainDropdownToggle?.element) {
                this.domainDropdownToggle.element.classList.add('is-invalid');
            }

            if (feedback) {
                feedback.textContent = Array.isArray(message) ? message[0] : message;
            }
        });
    }

    getFieldInput(field) {
        const map = {
            subdomain: this.subdomainInput,
            domain: this.domainInput,
            account_id: this.accountIdInput,
            access_token: this.accessTokenInput,
            is_active: this.isActiveInput,
        };

        return map[field]?.element;
    }

    clearErrors() {
        this.element.querySelectorAll('.is-invalid').forEach((el) => {
            el.classList.remove('is-invalid');
        });

        this.element.querySelectorAll('.invalid-feedback').forEach((el) => {
            el.textContent = '';
        });

        this.successAlert?.element?.classList.add('d-none');
    }

    setLoading(button, loading) {
        if (!button?.element) {
            return;
        }

        const spinner = button.element.querySelector('.spinner-border');
        button.element.disabled = loading;

        if (spinner) {
            spinner.classList.toggle('d-none', !loading);
        }
    }
}
